
import * as THREE from 'three';
import { CreatePointData, StraightLine } from '../index';
import * as marietta from '../../../';
import { PointInfo } from '../../WalltoFittingInfo';

/** 
 * グリッドに乗せる補正(戸建て) 
 * */
export class OnGrid {

    constructor(private pointList: PointInfo[]) {
        ;
    }
    
    public execute(): PointInfo[] {

        const pointData__ = new CreatePointData(this.pointList);
        pointData__.execute();
        const roomList__ = pointData__.roomList;

        this.pointList = new StraightLine(this.pointList, roomList__).execute();

        /** minx,minyの頂点を探してくる */
        let min = new THREE.Vector3(Infinity, Infinity, Infinity);
        let i: number | null = null;
        this.pointList.forEach((info: PointInfo, index: number) => {
            if (min.x > info.point.x && min.z > info.point.z) {
                min = info.point.clone();
                i = index;
            }
        });
        
        /**  offsetを出す */
        if (i != null) {
            const x =  marietta.webcad.util.WebCADUtil.convertMMToPix(this.pointList[i].point.x * 1000);
            const y = marietta.webcad.util.WebCADUtil.convertMMToPix(this.pointList[i].point.z * 1000);
            const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
            const _x = Math.round(x / snapUnit) * snapUnit;
            const _y = Math.round(y / snapUnit) * snapUnit;
            const offsetX = marietta.webcad.util.WebCADUtil.convertPixToM(x - _x);
            const offsetY = marietta.webcad.util.WebCADUtil.convertPixToM(y - _y);
            this.pointList = this.pointList.map((info: PointInfo) => {
                info.point.set(info.point.x - offsetX, info.point.y, info.point.z - offsetY);
                return info;
            });    
        }

        return this.pointList;
    }

}